import axios from '@/requests';
import {Target, TargetUser} from '@/store/modules/target/types';
import {User} from '@/store/modules/user/types';

export interface UpdateTargetForm {
    uid: string,
    projId: string,
    description: string,
}


export const targetAPI = {
    async getTargetListByProjId(id: string) {
        try {
            return await axios.get<Target[]>('/proj/listAllTargetByProjId', {"id": id});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async updateTarget(updateTargetMsg: UpdateTargetForm): Promise<Target> {
        try {
            return await axios.post<Target>('/target/updateTarget', updateTargetMsg);
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async deleteTarget(projId: string, uid: string): Promise<Target> {
        try {
            return await axios.get<Target>('/target/deleteTarget', {"projId": projId, "uid": uid});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getUsersByTarget(projId: string, uid: string): Promise<User[]> {
        try {
            return await axios.get<User[]>('/targetUser/getTargetUser', {"projId": projId, "uid": uid});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async createTargetUser(projId: string, uid: string, username: string): Promise<TargetUser> {
        try {
            return await axios.get<TargetUser>('/targetUser/createTargetUser', {
                "projId": projId,
                "uid": uid,
                "username": username
            });
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async deleteTargetUser(projId: string, uid: string, userId: number): Promise<TargetUser> {
        try {
            return await axios.get<TargetUser>('/targetUser/delTargetUser', {
                "projId": projId,
                "uid": uid,
                "userId": userId
            });
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getTargetByProjIdAndUid(projId: string, uid: string): Promise<Target> {
        try {
            return await axios.get<Target>('/target/getTargetByProjIdAndUid', {"projId": projId, "uid": uid});
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getDummyTarget(projId: string): Promise<string> {
        try {
            return await axios.get<string>('/target/getDummyTarget', {"projId": projId});
        } catch (err) {
            return Promise.reject(err);
        }
    },
}